import { En } from './En'
import { Ru } from './Ru'

export const FaqDocuments = {
  En,
  Ru,
}
